import React from "react";
import { useNetworkStatus } from "../hook/useNetworkStatus";
import "./networkWarning.css";

const InternetSpeedIndicator = () => {
  const quality = useNetworkStatus();

  // const config = {
  //   excellent: { label: "Net - High Speed", level: "high" },
  //   good: { label: "Net - Fair Speed", level: "high" },
  //   average: { label: "Net - Medium Speed", level: "medium" },
  //   poor: { label: "Net - Low Speed", level: "low" },
  // };

  const config = {
    excellent: { label: "Net - High Speed", level: "high" },
    good: { label: "Net - Medium Speed", level: "medium" },
    average: { label: "Net - Medium Speed", level: "medium" },
    poor: { label: "Net - Low Speed", level: "low" },
  };  

  // Optional: loading state
  if (quality === "unknown") {
    return (
      <div className="warning-box">
        <div className="speed-pill">
          <span className="speed-text">Checking network…</span>
        </div>
      </div>
    );
  }

  const current = config[quality];
  if (!current) return null;

  return (
    <div className="speed-pill">
      <div className={`signal ${current.level}`}>
        <span />
        <span />
        <span />
        <span />
      </div>
      <span className="speed-text">{current.label}</span>
    </div>
  );
};

export default InternetSpeedIndicator;
